import { ShoppingcartComponent } from './shoppingcart.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { CartComponent } from './cart/cart.component';
import { OrderCompleteComponent } from './order-complete/order-complete.component';
import { AddItemUsingEmailComponent } from './add-item-using-email/add-item-using-email.component';
import { OrderDetailComponent } from './order-detail/order-detail.component';

export const ShoppingCartRoutes = [
    {
    path: 'ShoppingCart',
    component: ShoppingcartComponent,
    children: [
        { path: 'checkout', component: CheckoutComponent },
        { path: 'GetShoppingCart', component: CartComponent , pathMatch : 'full' },
        { path: 'ordercomplete', component: OrderCompleteComponent  , pathMatch : 'full' },
        { path: 'AddShoppingCartItemsByLink', component: AddItemUsingEmailComponent  , pathMatch : 'full' },
        { path: 'OrderDetail', component: OrderDetailComponent  , pathMatch : 'full' },
        { path: '', redirectTo: 'GetShoppingCart'  , pathMatch : 'full'}
    ]
    },
    { path: '', redirectTo: 'ShoppingCart' , pathMatch : 'full'  },
    { path: '**', redirectTo: 'ShoppingCart', pathMatch: 'full' },
];



// WEBPACK FOOTER //
// ./src/app/shoppingcart/shoppingcart.route.ts